export default __webpack_public_path__ + "static/media/vib-request.c29adaf2.svg";